// extracted by mini-css-extract-plugin
module.exports = {"paging":"paging_paging__SaAyX"};